export default __webpack_public_path__ + "static/media/img_history.18a0479b.png";